import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@app/helpers/api.service';
import { CommonService } from '@app/helpers/common.service';
import { slideInRight, slideOutLeft } from 'ngx-animate';

@Component({
  selector: 'app-gdpr-info',
  templateUrl: './gdpr-info.component.html',
  styleUrls: ['./gdpr-info.component.scss'],
  animations: [
    trigger('inForm', [transition('void => *', useAnimation(slideInRight))]),
    trigger('outForm', [transition('* => void', useAnimation(slideInRight))]),
    trigger('inDetail', [transition('void => *', useAnimation(slideInRight))]),
    trigger('outDetail', [transition('* => void', useAnimation(slideOutLeft))]),
  ],
})
export class GdprInfoComponent implements OnInit {
  files: any[] = [];
  serviceInfo: any;
  officeId: any;
  formData: any = {};
  otpStatus = '';
  view = 'detail';
  selectedService: any;
  formView = 'description';
  otpSent: boolean;
  phoneVerified: boolean;
  userDetail: any;
  otp: any;

  types = [
    {
      title: 'externalSharedService.gdpr_apply_type1',
      type: 'gdpr_apply_type1',
      description: 'externalSharedService.gdpr_apply_type1_desc',
    },
    {
      title: 'externalSharedService.gdpr_apply_type2',
      type: 'gdpr_apply_type2',
      description: 'externalSharedService.gdpr_apply_type2_desc',
    },
    {
      title: 'externalSharedService.gdpr_apply_type3',
      type: 'gdpr_apply_type3',
      description: 'externalSharedService.gdpr_apply_type3_desc',
    },
    {
      title: 'externalSharedService.gdpr_apply_type4',
      type: 'gdpr_apply_type4',
      description: 'externalSharedService.gdpr_apply_type4_desc',
    },
    {
      title: 'externalSharedService.gdpr_apply_type5',
      type: 'gdpr_apply_type5',
      description: 'externalSharedService.gdpr_apply_type5_desc',
    },
    {
      title: 'externalSharedService.gdpr_apply_type6',
      type: 'gdpr_apply_type6',
      description: 'externalSharedService.gdpr_apply_type6_desc',
    },
    {
      title: 'externalSharedService.gdpr_apply_type7',
      type: 'gdpr_apply_type7',
      description: 'externalSharedService.gdpr_apply_type7_desc',
    },
  ];
  extraData: any;

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.officeId = this.commonService.getOfficeId(this.route);
    if (this.officeId) {
      this.getData();
    } else {
      this.router.navigateByUrl('/');
    }
  }

  async getData() {
    try {
      this.commonService.onLoaderChange.next(true);
      // this.serviceInfo = await this.commonService.getAboutService(this.officeId, this.route.snapshot.params.serviceId);
      this.getDataV2();
      this.formInitView();
      this.commonService.onLoaderChange.next(false);
    } catch (error) {
      console.error(error);
      this.commonService.onLoaderChange.next(false);
    }
  }

  registerCase() {
    this.view = 'form';
  }

  formInitView() {
    if (this.serviceInfo && this.serviceInfo.formShowDescription === 'Yes') {
      this.formView = 'description';
    } else {
      this.formView = 'email';
    }
  }

  async getDataV2() {
    try {
      this.commonService.onLoaderChange.next(true);
      this.serviceInfo = await this.commonService.getAboutService(
        '5cb9648308e32961acf1ff1f.pages.pinbox24.com',
        '615ff48e1223a815f8200a29'
      );
      // this.formInitView();
      this.commonService.onLoaderChange.next(false);
    } catch (error) {
      console.error(error);
      this.commonService.onLoaderChange.next(false);
    }
  }
  async submit() {
    try {
      if (this.formData.email) {
        // this.view2 = 'table';
        try {
          this.formData.nextServiceId = this.serviceInfo._id;
          this.formData.subType = this.serviceInfo.serviceType;
          this.formData.gdprType = this.selectedService.type;
          this.formData.description = `global.new_service_desc - ${this.serviceInfo.serviceName}`;
          this.formData.mainServiceName = this.serviceInfo.serviceName;
          this.commonService.onLoaderChange.next(true);
          this.extraData = await this.apiService.postRequest(`/webook/start-shared-service`, this.formData, {
            'webhook-token': this.serviceInfo.webhookToken,
          });
          this.commonService.onLoaderChange.next(false);
          // alert("Service Started");
          this.formView = 'thanks';
        } catch (error) {
          this.commonService.onLoaderChange.next(false);
          this.formView = 'error';
          // this.extraData = error;
          // alert(error);
        }
      } else {
        alert('Email is required');
      }
    } catch (error) {
      this.formView = 'error';
      this.formView = 'thanks';
    }
  }

  nextStep() {
    switch (this.formView) {
      case 'description':
        this.formView = 'email';
        break;
      case 'email':
        if (this.serviceInfo && this.serviceInfo.formShowPhoneVerify === 'Yes') {
          this.formView = 'phoneVerify';
        } else {
          // this.formView = 'thanks';
          this.submit();
        }
        break;
      case 'phoneVerify':
        this.formView = 'otpView';
        break;
      case 'otpView':
        // this.formView = 'thanks';
        this.submit();
        break;
    }
  }

  previousStep() {
    switch (this.formView) {
      case 'description':
        break;
      case 'email':
        if (this.serviceInfo && this.serviceInfo.formShowDescription === 'Yes') {
          this.formView = 'description';
        }
        break;
      case 'phoneVerify':
        this.formView = 'email';
        break;
    }
  }

  async sendOtp() {
    if (this.formData.phoneNo) {
      this.commonService.onLoaderChange.next(true);
      try {
        await this.apiService.postRequest(`/auth/send-otp`, { phoneNo: this.formData.phoneNo, lang: 'en' });
        this.otpSent = true;
        this.otpStatus = 'OTP_SENDED';
        this.commonService.onLoaderChange.next(false);
        this.nextStep();
      } catch (error) {
        this.commonService.onLoaderChange.next(false);
      }
    }
  }

  async verifyOtp() {
    if (this.formData.phoneNo && this.otp) {
      try {
        this.commonService.onLoaderChange.next(true);
        await this.apiService.postRequest(`/auth/verify-otp`, { phoneNo: this.formData.phoneNo, otp: this.otp });
        this.otpStatus = 'OTP_VERIFIED';
        this.phoneVerified = true;
        this.userDetail = this.userDetail || {};
        this.userDetail.phoneNoVerified = true;
        this.commonService.onLoaderChange.next(false);
        this.nextStep();
      } catch (error) {
        this.otpStatus = 'INVALID_OTP';
        this.commonService.onLoaderChange.next(false);
      }
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files: any) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: any, decimals?: any) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
